import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './icons'
import './utils/rem.js'
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './styles/position.css'
import './styles/font.css'
import 'swiper/dist/css/swiper.css';
import config from './utils/config'
import axios from 'axios'
import layer from "layui-layer";
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.config.productionTip = false
Vue.prototype.global=config
new Vue({
  router,
  store,
  $,
  render: function (h) { return h(App) }
}).$mount('#app')
